<template>
    <div class="c-input-date">
        <div class="day">
            <InputSelect v-model:value="getDay" :options="days" :editable="true" :error="daysError" :tabindex="tabindex > -1 ? tabindex : -1"/>
        </div>
        <div class="month">
            <InputSelect v-model:value="getMonth" :options="months" :editable="true" :error="monthsError" :tabindex="tabindex > -1 ? tabindex + 1: -1"/>
        </div>
        <div class="years">
            <InputSelect v-model:value="getYear" :options="years" :editable="true" :error="yearsError" :tabindex="tabindex > -1 ? tabindex + 2: -1"/>
        </div>
    </div>
</template>

<script>
import InputSelect from "@/components/InputSelect.vue";
import {fillArrayWithFromTo, getDateForPicker} from "@/utils/utils.js";

export default {
    name : "InputDate",
    components: {
        InputSelect
    },
    props: {
        date : {
            type:String,
            default() {
                return "";
            }
        },
        tabindex : {
            type:Number,
            default: -1
        }
    },

    data() {
        return {
            days : [],
            months : [],
            years : []
        };
    },

    created() {
        const now = new Date();
        const currentYear = now.getFullYear();
        const startDate = currentYear - 120;

        this.days = fillArrayWithFromTo(1, 31);
        this.months = fillArrayWithFromTo(1, 12);
        this.years = fillArrayWithFromTo(startDate, currentYear);
    },

    computed: {
        getDay: {
            get: function() {
                return this.getFromDate(2);
            },
            set: function(value) {
                this.setToDate(value, 2);
            }
        },

        getMonth: {
            get: function() {
                return this.getFromDate(1);
            },
            set: function(value) {
                this.setToDate(value, 1);
            }
        },

        getYear: {
            get: function() {
                return this.getFromDate(0);
            },
            set: function(value) {
                this.setToDate(value, 0);
            }
        },

        daysError() {
            return (this.getDay < 1 || this.getDay > 31) && this.date !== "";
        },

        monthsError() {
            return (this.getMonth < 1 || this.getMonth > 12) && this.date !== "";
        },

        yearsError() {
            return (this.getYear < 1900 || this.getYear > 9999) && this.date !== "";
        }
    },

    methods : {
        getFromDate(idx) {
            const arr = this.date.split("-");
            const val = parseInt(arr[idx]);
            if (isNaN(val)) {
                return "";
            }
            return arr.length > idx ? val : 0;
        },

        setToDate(value, idx) {
            let arr = this.date.split("-");
            arr[idx] = this.padZeroLeft(value);
            const date = arr.join("-");
            if (date === "--") {
                this.$emit("update:date", "");
                return;
            }

            this.$emit("update:date", date);
        },

        padZeroLeft(value, length = 2) {
            const numValue = parseInt(value, 10);
            if (isNaN(numValue)) {
                return "";
            }
            return String(numValue).padStart(length, "0");
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-input-date {
        display: flex;
        width: 50%;
        border: 1px solid transparent;

        .day {
            width : 25%;
            margin-right : 5%;
        }

        .month {
            width : 25%;
            margin-right : 5%;
        }

        .years {
            width : 50%;
            margin-right : 5%;
        }
    }
</style>